export function FullPageSpinner() {
  return (
    <div className="full-page-spinner" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
